import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import AppAppBar from "./components/app-bar/AppAppBar";
import { CreateCV } from "./pages/CreateCV";
import SignIn from "./pages/SignIn";
import Dashboard from "./pages/Dashboard";
import PDFViewerComponent from "./pages/PDFViewerComponent";
import { AuthProvider } from "./hooks/useAuth";
import ProtectedRoute from "./components/routes/ProtectedRoute";
import UserManagement from "./pages/UserManagement";
import DefinitionsPositions from "./pages/Positions";
import DefinitionsTrainings from "./pages/Trainings";
import ResetPassword from "./pages/ResetPassword";
import FirstTimeLogin from "./pages/FirstTimeLogin";
import VerifyEmail from "./pages/VerifyEmail";
import DefinitionsSkills from "./pages/Skills";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppAppBar />
        <Routes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/first-time-login" element={<FirstTimeLogin />} />
          {/* Authenticated-only pages */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <CreateCV />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-cv"
            element={
              <ProtectedRoute>
                <CreateCV />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute requiredRole="Admin">
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-management"
            element={
              <ProtectedRoute requiredRole="Admin">
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/definitions/positions"
            element={
              <ProtectedRoute requiredRole="Admin">
                <DefinitionsPositions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/definitions/skills"
            element={
              <ProtectedRoute requiredRole="Admin">
                <DefinitionsSkills />
              </ProtectedRoute>
            }
          />
          <Route
            path="/definitions/trainings"
            element={
              <ProtectedRoute requiredRole="Admin">
                <DefinitionsTrainings />
              </ProtectedRoute>
            }
          />
          <Route
            path="pdf-viewer"
            element={
              <ProtectedRoute>
                <PDFViewerComponent />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
